import { RouteKeys } from "@/api_framework/api_modals/Routers";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useEffect, useState } from "react";

const RBACFlag: React.FC<React.PropsWithChildren<{ actionId: RouteKeys; invalidateRule?: () => boolean }>> = ({
  actionId,
  invalidateRule,
  children,
}) => {
  const [actions, setActions] = useState<Array<string>>([]);
  const userPermissions = useAppSelector((state) => state?.auth?.userPermissions);

  useEffect(() => {
    if (userPermissions?.role_permission && userPermissions?.role_permission?.actions?.length > 0) {
      setActions(userPermissions?.role_permission?.actions);
    } else {
      setActions([]);
    }
  }, [userPermissions]);

  const renderComponent = () => {
    if (invalidateRule) {
      if (invalidateRule() && actions.includes(actionId)) {
        return children;
      } else {
        return null;
      }
    } else {
      return actions?.length === 0 ? children : actions.length > 0 && actions.includes(actionId) ? children : null;
    }
  };

  return renderComponent();
};

export default RBACFlag;
